// AI 打分加点评, 问小助手 menu, 课外读物推荐, build info
const en = {
  // ai-score-review
  "未分配学校": "No school assigned",
  "{year}年 {1}": "{year} {1}",
  "未设置学期": "Term not set",
  "{0} 分 {1} 秒": "{0} min {1} s",
  "{sec} 秒": "{sec} s",
  "打分加点评中": "Scoring & reviewing",
  "打分中": "Scoring",
  "点评中": "Reviewing",
  "AI 打分加点评仅对专家和管理员开放。": "AI Scoring & Review is available to experts and admins only.",
  "将为当前显示的 {pending.length} 个课程处理：其中 {combinedCount} 个同时打分加点评，{2} 个仅打分，{3} 个仅点评（每个课程一次 AI 调用，约需 1-2 分钟），确定开始吗？":
    "This will process the {pending.length} courses shown: {combinedCount} scored and reviewed, {2} scored only, {3} reviewed only (one AI call per course, about 1-2 minutes each). Start?",
  "开始（{pending.length} 个待处理课程）": "Start ({pending.length} pending courses)",
  "每个已提交课程都有一份 AI 打分与 AI 计划整体点评，出自同一次 AI 调用，":
    "Each submitted course gets an AI score and an AI overall review from a single AI call, ",
  "依据当前生效的": "based on the active ",
  "AI 点评标准（版本 #{standard.id}）": "AI review rubric (version #{standard.id})",
  "（满分 {standard.totalScore}），": " (max {standard.totalScore}), ",
  "依据当前生效的 AI 点评标准，": "based on the active AI review rubric, ",
  "并核查课程的目标一致性与完整性。打分与点评在教师或专家「请AI点评」时生成":
    " and checks the course's goal alignment and completeness. Scores and reviews are generated when a teacher or expert clicks \"Ask AI to review\"",
  "，也可在此为当前显示的待处理课程统一生成（每个课程只补齐所缺的部分）。":
    ", or can be generated here in bulk for the pending courses shown (filling in only what each course is missing). ",
  "，或由管理员统一生成。": ", or in bulk by an admin. ",
  "设计/实施完成度与": " Design/implementation completion matches the ",
  "一致。": ".",
  "尚未制定 AI 点评标准，请先在": "No AI review rubric yet. Please generate one in",
  "中生成。": "first.",
  "正在处理：已完成 {processed} / {job.queued}（已打分 {job.scored} / {job.scoreQueued}，已点评 {job.reviewed} / {job.reviewQueued}）":
    " Processing: {processed} / {job.queued} done (scored {job.scored} / {job.scoreQueued}, reviewed {job.reviewed} / {job.reviewQueued}) ",
  "已用时": "Elapsed",
  "进行中：": "In progress: ",
  "课程 #{p.planId}": "Course #{p.planId}",
  "最近一次运行完成于": "Last run finished at",
  "没有需要处理的课程。": "No courses need processing.",
  "新打分 {job.scored} 个，新点评 {job.reviewed} 个（其中 {job.combined} 个同时完成）{3}。":
    "{job.scored} newly scored, {job.reviewed} newly reviewed ({job.combined} both){3}.",
  "，失败 {job.failed} 个": ", {job.failed} failed",
  "课程 #{e.planId}": "Course #{e.planId}",
  "暂无已提交的课程。": "No submitted courses yet.",
  "学期筛选": "Term filter",
  "全部学期": "All terms",
  "教师姓名筛选": "Teacher filter",
  "按教师姓名搜索": "Search by teacher name",
  "学校名称筛选": "School filter",
  "搜索学校（名称/代码）": "Search schools (name / code)",
  "主题筛选": "Theme filter",
  "全部主题": "All themes",
  "总体设计完成度": "Overall design completion",
  "不限": "Any",
  "% 至": "% to",
  "分课时设计完成度": "Lesson design completion",
  "实施完成度": "Implementation completion",
  "AI 设计分数": "AI design score",
  "至": "to",
  "尚缺最新 AI 打分或 AI 点评的课程": "Courses missing an up-to-date AI score or AI review",
  "待处理": "Pending",
  "AI已点评": "AI reviewed",
  "专家已点评": "Expert reviewed",
  "共 {plans.length} 个课程": "{plans.length} courses",
  "筛选出 {visiblePlans.length} / {plans.length} 个课程": "Showing {visiblePlans.length} / {plans.length} courses",
  "，已打分 {scored.length} 个": ", {scored.length} scored ",
  "，平均分 {average}": ", average {average}",
  "，待处理 {pending.length} 个（待打分 {scoreCount}，待点评 {reviewCount}）。 点击行查看各维度打分理由与 AI 点评。设置总分条件时，未打分的课程不在范围内。":
    ", {pending.length} pending ({scoreCount} to score, {reviewCount} to review). Click a row to see per-dimension reasoning and the AI review. Unscored courses are excluded when a total-score filter is set.",
  "课程": "Course",
  "学校 / 教师": "School / Teacher",
  "总分": "Total",
  "各维度得分": "Dimension scores",
  "打分 / 点评时间": "Scored / reviewed at",
  "没有符合筛选条件的课程。": "No courses match the filters.",
  "未打分": "Not scored",
  "待打分": "To score",
  "打分：": "Scored: ",
  "无": "None",
  "旧标准 #{s.standardId}": "Old rubric #{s.standardId}",
  "课程内容已修改": "Course content changed",
  "点评：": "Reviewed: ",
  "待点评": "To review",
  "打分理由": "Scoring rationale",
  "AI 点评": "AI review",
  "（无）": "(none)",
  "标准版本 #{s.standardId}": "Rubric version #{s.standardId}",
  "标准版本 #{rv.standardId}": "Rubric version #{rv.standardId}",
  "未依据标准": "No rubric used",
  " · 课程内容已在点评后修改": " · Course content changed after review",

  // ask-ai-menu (presets are sent as the user's own chat message)
  "帮我完善": "Help me improve",
  "请帮我完善「{name}」{unit}：先指出目前内容的主要不足，再给出可以直接替换使用的修改稿。":
    "Please help me improve \"{name}\" {unit}: first point out the main weaknesses of the current content, then give a revised version I can use directly.",
  "这里该怎么写": "What goes here?",
  "「{name}」{unit}应该写什么？请结合本课程的主题、年级和地区说明要点，并给一个简短示例。":
    "What should \"{name}\" {unit} contain? Explain the key points given this course's theme, grade and region, with a short example.",
  "找思路和资料": "Ideas & resources",
  "请为「{name}」{unit}提供一些结合本地乡土资源的思路，并推荐相关参考资料。":
    "Please suggest some ideas for \"{name}\" {unit} that draw on local resources, and recommend related references.",
  "检查前后一致": "Check consistency",
  "请检查「{name}」{unit}与本课程设计其他部分（尤其是学习目标）是否一致，列出不一致或缺失之处。":
    "Please check whether \"{name}\" {unit} is consistent with the rest of this course design (especially the learning goals), and list any inconsistencies or gaps.",
  "解读这里": "Explain this",
  "请简要解读「{name}」{unit}的内容和设计意图。": "Please briefly explain the content and design intent of \"{name}\" {unit}.",
  "有什么可借鉴": "What can I borrow?",
  "「{name}」{unit}有哪些值得我在自己的课程设计中借鉴的做法？": "What practices in \"{name}\" {unit} are worth borrowing for my own course design?",
  "推荐标题": "Suggest titles",
  "请结合我校所在地的乡土资源，以及已选的乡土主题和年级，推荐 3–5 个可直接使用的课程标题，每个附一句理由。":
    "Based on my school's local resources and the selected theme and grade, suggest 3-5 ready-to-use course titles, each with a one-sentence reason.",
  "推荐乡土主题": "Suggest a theme",
  "请根据我校所在地区以及已填写的标题，推荐最合适的乡土主题，并说明理由。":
    "Based on my school's region and the title entered, recommend the most suitable local theme and explain why.",
  "检查信息匹配": "Check basic info",
  "请检查基本信息各项（标题、乡土主题、年级、学生人数、预计课时）是否相互匹配、是否立足我校当地，列出问题并给出调整建议。":
    "Please check whether the basic info (title, theme, grade, student count, planned lessons) is consistent and grounded in my school's locality, list any issues and suggest adjustments.",
  "这一栏": "(this field)",
  "就「{name}」问欣欣小助手": "Ask Xinxin Assistant about \"{name}\"",
  "小助手": "Assistant",
  "就「{name}」{unit}：": "About \"{name}\" {unit}:",
  "自由提问…": " Ask anything…",

  // book-recommendation
  "检索地方规定": "Searching local regulations",
  "检索图书信息": "Searching book info",
  "AI 合规评估": "AI compliance check",
  "运行中": "Running",
  "失败": "Failed",
  "已完成": "Done",
  "依据文件：": "Source documents:",
  "未检索到本省专门文件，以国家规定为准。": "No province-specific documents found; national regulations apply.",
  "禁止进校园的情形（红线）：": "Prohibited from schools (red lines):",
  "推荐原则：": "Recommendation principles:",
  "学段要求：": "Grade-band requirements:",
  "{k} 年级：{v}": "Grades {k}: {v}",
  "本省特别要求：": "Province-specific requirements:",
  "检索来源（{guidance.sources.length}）": "Sources ({guidance.sources.length})",
  "检索于 {fmtTime(guidance.fetchedAt)}": "Retrieved {fmtTime(guidance.fetchedAt)}",
  "图书": "Book",
  "豆瓣评分": "Douban rating",
  "推荐理由": "Reason",
  "原因": "Reason",
  "说明": "Notes",
  "上传的 ISBN 为 {b.inputIsbn}，检索到的为 {b.foundIsbn}": "Uploaded ISBN is {b.inputIsbn}; found {b.foundIsbn}",
  "新ISBN": "New ISBN",
  "有疑点": "Questionable",
  "人": "ratings",
  "未检索到内容简介。": "No synopsis found.",
  "主题：": "Themes: ",
  "获奖 / 入选：": "Awards / lists: ",
  "疑点：": "Concerns: ",
  "上传书名：{b.inputTitle}": "Uploaded title: {b.inputTitle}",
  "来源：": "Sources: ",
  "链接": "Link",
  "导出失败：{errorText(e)}": "Export failed: {errorText(e)}",
  "用同一书目和学校重新运行？已检索过的图书和地方规定会直接复用缓存。":
    "Re-run with the same book list and school? Books and regulations already searched will be reused from cache.",
  "加载中…": "Loading…",
  "不推荐（{result.excluded.length}）": "Not recommended ({result.excluded.length})",
  "待人工复核（{result.review.length}）": "Needs manual review ({result.review.length})",
  "依据规定": "Regulations",
  "返回推荐记录": " Back to runs",
  "{run.province} · 书目「{run.fileName}」共 {run.bookCount} 本 · 发起于 {fmtTime(run.createdAt)}":
    "{run.province} · list \"{run.fileName}\", {run.bookCount} books · started {fmtTime(run.createdAt)} ",
  " · 完成于 {fmtTime(run.finishedAt)}": " · finished {fmtTime(run.finishedAt)}",
  "导出 Excel": " Export Excel",
  "重新运行": "Re-run",
  "处理中": "Processing",
  "每本书需联网检索，首次检索约 20-40 秒/本；已检索过的图书和地方规定直接使用缓存。":
    "Each book is looked up online, about 20-40 s per book the first time; books and regulations already searched come from cache.",
  "共 {result.counts.total} 本：推荐": "{result.counts.total} books: recommended",
  "本，不推荐 ": ", not recommended ",
  "本，待人工复核": ", needs review",
  "本。点击行查看简介与来源。 AI 生成的结果，正式使用前请人工审核。":
    ". Click a row for the synopsis and sources. Results are AI-generated; please review manually before use.",
  "新建推荐": "New run",
  "受赠学校": "Recipient school",
  "搜索学校（名称/代码/地址）": "Search schools (name / code / address)",
  "所在省份": "Province",
  "选择学校后自动确定": "Set automatically from the school",
  "推荐学段（按课程标准学段分组）": "Grade bands (grouped per curriculum standards)",
  "书目文件（.xlsx / .csv）": "Book list file (.xlsx / .csv)",
  "第一行为表头，需包含「书名」和/或「ISBN」（或「书号」）列；可选列：作者、出版社、出版年。一次最多 500 本。":
    "The first row is the header and must include a 书名 (title) and/or ISBN (or 书号) column; optional columns: 作者, 出版社, 出版年. Up to 500 books per run.",
  "提交中…": "Submitting…",
  "开始推荐": "Start",
  "重新联网检索{province}的课外读物进校园规定？约需 1-2 分钟。": "Re-search {province}'s school reading regulations online? Takes about 1-2 minutes.",
  "地方规定（已缓存，半年自动更新）": "Local regulations (cached, refreshed every 6 months)",
  "暂无。首次为某省推荐时会自动检索该省规定。": "None yet. A province's regulations are searched automatically the first time it's used.",
  "省份": "Province",
  "依据文件": "Documents",
  "红线": "Red lines",
  "检索时间": "Retrieved",
  "仅国家规定": "National only",
  "{r.content.documents.length} 份": "{r.content.documents.length}",
  "{r.content.redLines.length} 条": "{r.content.redLines.length}",
  "待更新": "Stale",
  "检索中": " Searching",
  "重新检索": "Re-search",
  "图书检索": "Book search",
  "指导检索": "Regulation search",
  "技能经验（每次运行后自动总结改进）": "Learned skills (auto-refined after each run)",
  "第 {n.revision} 版 · {fmtTime(n.updatedAt)}": "Revision {n.revision} · {fmtTime(n.updatedAt)}",
  "尚无经验": "Nothing learned yet",
  "删除「{run.schoolName}」的这次推荐记录？": "Delete this run for \"{run.schoolName}\"?",
  "上传书目并选择受赠学校，系统先检索学校所在省份的课外读物进校园规定（国家《中小学生课外读物进校园管理办法》及省级规定）， 再逐本检索图书信息（豆瓣读书 ISBN 页面及联网检索），由 AI 对照规定判断是否推荐，并按课程标准学段分组。 检索结果会缓存复用，检索技能会根据每次运行的经验自动改进。":
    "Upload a book list and pick the recipient school. The system first looks up the reading regulations for the school's province (the national rules on extracurricular reading in schools plus provincial rules), then looks up each book (Douban ISBN pages and web search). AI checks each book against the regulations, decides whether to recommend it, and groups it by curriculum grade band. Search results are cached for reuse, and the search skills improve automatically after each run.",
  "推荐记录": "Runs",
  "暂无。": "None yet.",
  "学校": "School",
  "书目": "Book list",
  "结果": "Results",
  "发起时间": "Started",
  "{r.fileName}（{r.bookCount} 本）": "{r.fileName} ({r.bookCount} books)",
  "推荐 {r.counts.recommended} · 不推荐 {r.counts.excluded} · 待复核 {r.counts.review}":
    "Recommended {r.counts.recommended} · Not recommended {r.counts.excluded} · Review {r.counts.review}",
  "课外读物推荐仅对超级管理员开放。": "Reading List is available to super admins only.",

  // build-info
  "开发环境": "Development",
  "版本信息": "Build info",
  "刷新": "Refresh",
  "前端（{FRONTEND.tag}）与后端（{backend.tag}）版本不一致，请刷新页面或检查部署。":
    "Frontend ({FRONTEND.tag}) and backend ({backend.tag}) versions differ. Refresh the page or check the deploy.",
  "后端版本信息获取失败：{error}": "Failed to fetch backend build info: {error}",
  "后端构建": "Backend build",
  "前端构建": "Frontend build",
  "提交时间": "Committed",
  "构建时间": "Built",
  "部署（启动）时间": "Deployed (started)",
  "最新数据库迁移": "Latest DB migration",
  "版本信息（仅超级管理员可见）": "Build info (super admins only)",
  " · 部署于 {short(backend.startedAt)}": " · deployed {short(backend.startedAt)}",
  " · 版本不一致": " · version mismatch",
};
export default en;
